"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptExecutionError = exports.ScriptTimeoutError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
const stringUtils_1 = require("../common/stringUtils");
const types_1 = require("./types");
/**
 * Script execution timeout
 */
class ScriptTimeoutError extends teamsfx_api_1.UserError {
    constructor(error, script) {
        const maskedScript = (0, stringUtils_1.maskSecret)(script, { replace: "***" });
        const errorOptions = {
            source: "script",
            name: "ScriptTimeoutError",
            message: (0, localizeUtils_1.getDefaultString)("error.script.ScriptTimeoutError", maskedScript),
            displayMessage: (0, localizeUtils_1.getLocalizedString)("error.script.ScriptTimeoutError.Notification"),
            error: error,
            categories: [types_1.ErrorCategory.External],
        };
        super(errorOptions);
    }
}
exports.ScriptTimeoutError = ScriptTimeoutError;
/**
 * Script execution error
 */
class ScriptExecutionError extends teamsfx_api_1.UserError {
    constructor(error, script) {
        const maskedScript = (0, stringUtils_1.maskSecret)(script, { replace: "***" });
        const maskedError = (0, stringUtils_1.maskSecret)(error.message || "", { replace: "***" });
        const maskedUserData = (0, stringUtils_1.maskSecret)(JSON.stringify(error, Object.getOwnPropertyNames(error)), {
            replace: "***",
        });
        const errorOptions = {
            source: "script",
            name: "ScriptExecutionError",
            message: (0, localizeUtils_1.getDefaultString)("error.script.ScriptExecutionError", maskedScript, maskedError),
            displayMessage: (0, localizeUtils_1.getLocalizedString)("error.script.ScriptExecutionError.Notification", maskedError),
            error: error,
            categories: [types_1.ErrorCategory.External],
            userData: maskedUserData,
        };
        super(errorOptions);
    }
}
exports.ScriptExecutionError = ScriptExecutionError;
//# sourceMappingURL=script.js.map